import { useState, useEffect } from "react";

const ZERO = { days: 0, hours: 0, minutes: 0, seconds: 0, isPast: false };

const diff = (targetDate) => {
  const total = targetDate.getTime() - Date.now();
  if (total <= 0) return { ...ZERO, isPast: true };
  return {
    days: Math.floor(total / (1000 * 60 * 60 * 24)),
    hours: Math.floor((total / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((total / (1000 * 60)) % 60),
    seconds: Math.floor((total / 1000) % 60),
    isPast: false,
  };
};

/**
 * Live countdown to a target date, updating once per second.
 * Usage: const time = useCountdown(new Date("2026-10-18T00:00:00+05:30"));
 */
const useCountdown = (targetDate) => {
  const [timeLeft, setTimeLeft] = useState(() => diff(targetDate));

  useEffect(() => {
    const tick = () => setTimeLeft(diff(targetDate));
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetDate.getTime()]);

  return timeLeft;
};

export default useCountdown;
